export default __webpack_public_path__ + "static/media/no_image_landscape.1dab0557.jpg";